import { graphql } from "@server/gql";

export const getAdyenCheckoutOrderForCompleteQuery = graphql(/* GraphQL */ `
  query getAdyenCheckoutOrderForComplete(
    $marketCode: String!
    $brandCode: String!
    $sessionId: String!
    $sessionResult: String
    $orderRef: String!
  ) {
    adyenCheckoutOrderForComplete(
      sessionId: $sessionId
      orderRef: $orderRef
      sessionResult: $sessionResult
      marketCode: $marketCode
      brandCode: $brandCode
    ) {
      orderId
      currencyCode
      totalOrderValue
      totalOrderValueExVatExShipping
      totalVat
      totalShipping
      totalShippingExVat
      couponCode
      items {
        partNo
        lineNo
        name
        brandName
        quantity
        totalDiscount
        unitPriceIncVat
        unitPriceExVat
      }
      customerData {
        email
        phoneNumber
        cellPhoneNumber
        firstName
        lastName
        street
        addressLine2
        city
        region
        postalCode
        country
      }
      customerDataSellTo {
        email
        phoneNumber
        cellPhoneNumber
        firstName
        lastName
        street
        addressLine2
        city
        region
        postalCode
        country
      }
      customerDataShipTo {
        email
        phoneNumber
        cellPhoneNumber
        firstName
        lastName
        street
        addressLine2
        city
        region
        postalCode
        country
      }
      cart {
        ...cart
      }
    }
  }
`);
